<template>
    <div class="container row-fluid span12 p-5">
      <div class="span2"></div>
      <div class="span6">
        <div class="container">
          <div class="row">
            <div class="col-3 pl-0 ml-0 mt-3">
              <picture>
                <source src="/static/cm-red.png" type="image/svg+xml">
                <a href=".."><img src="/static/cm-red.png" height="200" width="150"
                                  class="img-fluid" alt="..."></a>
              </picture>
            </div>
            <div class="col-9 pt-4">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item active" aria-current="page">主页</li>
                  <li v-for="url in urls" class="breadcrumb-item">
                    <a :href="url[1]">{{url[0]}}</a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        <ul class="nav nav-tabs pt-4 pl-1" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
              概要
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="tech-tab" data-toggle="tab" href="#tech" role="tab" aria-controls="tech" aria-selected="false">
              技术
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
              资料
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">
              联系方式
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="contact2-tab" data-toggle="tab" href="#contact2" role="tab" aria-controls="contact2"
               aria-selected="false">
              网站可用性
            </a>
          </li>
        </ul>
        <div class="tab-content pl-1">

          <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="row">
                <div class="col-lg-7 pt-4 text-wrap">
                    <p>
                      庸人一个，热衷于写作（自然语言和程序语言）。研究生毕业于华中师大，涉猎领域包括：脑认知和虚拟现实，
                      曾（狂妄的）给 PNAS 和 Nature 子刊 投过稿，也发过专利。对摄影、平面设计和绘画有些许涉猎。
                      最喜欢的程序设计语言是 Clojure，<i>也经常用 Rust 和 Swift</i>。
                      </p>
                  <p>我的技术栈包含了前端、后端和客户端，主要从事 Web 后端开发，业务涉及 SDN 软件定义云数据中心网络。
                  <hr/>
                  后端与业务: Clojure/Kotlin/Rust :: Spring/ODL/Redis/Kafka/PostgreSQL
                  <hr/>
                  移动与桌面: Swift/Dart :: SwiftUI/Flutter/Java(Scala,Clj)Fx
                  <hr/>
                  Web 前端: ClojureScript :: React.js
                  <hr/>
                  云和网络: Python/Go :: OpenStack(Neutron)
                  <hr/>
                  <p>
                    拙作参见： <a target="_blank" href="https://github.com/corkine">Git 仓库</a><br/>
                    基于微软待办和 Apple Health 的运动监测、周计划、日记、周报和长期目标激励的自我改进平台 CyberMe
                    (<a target="_blank" href="https://github.com/corkine/OpenCyberMe">Clojure 后端</a>、
                    <a target="_blank" href="https://github.com/corkine/OpenCyberMe">ClojureScript 前端</a>、
                    <a target="_blank" href="https://github.com/corkine/cyberMeFlutter">Flutter Android 客户端</a>、
                    <a target="_blank" href="https://github.com/corkine/cyberMeSwift">Swift iOS 客户端</a>、
                    <a target="_blank" href="https://github.com/corkine/cyberMeGo">Go 后端</a>）。
                    基于 JavaFx 的心理学实验工具包 <a target="_blank" href="https://psy4j.mazhangjing.com">Psy4J</a>。
                    分布式 Python/Go 爬虫和 SpringBoot 采集中心（爬取中高考成绩）
                    <a target="_blank" href="https://mazhangjing.com/huginn">Huginn</a>。
                    PyQt 糊的正则/联网/查快递/日记 GUI 程序，笔记系统
                    <a href="#">Muninn</a>。
                    Scala 和 Play 搭建的健康采集和物品收集中心 <a target="_blank" href="https://status.mazhangjing.com">statusPlay</a> 、
                    短连接跳转器<a target="_blank" href="https://go.mazhangjing.com"> goPlay</a>
                    以及一个 Go 写的 <a target="_blank" href="https://static2.mazhangjing.com">小马图床</a>，
                    以及一堆奇淫技巧的 Clojure(babashka) 脚本：Java 语法解析器、Maven 构建脚本、WebDriver 自动化等。
                  </p>
                  <p>
                    我在学习这些技术的同时积累了很多的感悟（以及很多不着调的诗歌），欢迎访问我的
                    <a target="_blank" href="https://blog.mazhangjing.com">博客</a>，所有的文章都在那里。
                  </p>
                </div>
                <div class="col-lg-5 pt-4">
                  <img :src="backgroundImage()" width="100%"/>
                  <p style="padding-top: 3px;color: lightgray;float:right;font-size: 0.8em">{{note()}}</p>
                </div>
              </div>
          </div>

          <div class="tab-pane" id="tech" role="tabpanel" aria-labelledby="tech-tab">
            <div class="container pt-4">
              <Tech/>
            </div>
          </div>

          <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="container pt-4">
              <div class="row">
                <div class="col-2 pl-0">
                  <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">
                      简历
                    </a>
                    <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">
                      技术
                    </a>
                    <a class="nav-link" id="v-pills-design-tab" data-toggle="pill" href="#v-pills-design" role="tab" aria-controls="v-pills-design" aria-selected="false">
                      设计
                    </a>
                    <a class="nav-link" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false">
                      摄影
                    </a>
                    <a class="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false">
                      写作
                    </a>
                  </div>
                </div>
                <div class="col-10">
                  <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                      <div>
                        <p class="lead">教育情况</p>
                        <p>硕士学位 - 基础心理学 - 2017/2020 - 华中师范大学</p>
                        <p>学士学位 - 心理学（双学位）- 2015/2017 - 华中师范大学</p>
                        <p>学士学位 - 农学 - 2013/2017 - 华中农业大学</p>
                        <!--<p class="lead">实践经历</p>
                        <p>手机中国 - 资讯编辑（兼）</p>
                        <p>传神翻译(武汉) - 翻译后排版设计师（兼）</p>
                        <p>学而思教育科技集团 - 数据分析（兼）</p>
                        <p>浪潮思科 - SDN 软件开发工程师</p>-->
                        <p class="lead">工作经历</p>
                        <p>浪潮思科 - 云数据中心网络虚拟化工程师（OpenStack Neutron SDN，硬件 Overlay）</p>
                      </div>
                      <div class="LI-profile-badge"  data-version="v1" data-size="medium" data-locale="zh_CN" data-type="horizontal" data-theme="light" data-vanity="corkine">
                        <a class="LI-simple-link" href='https://cn.linkedin.com/in/corkine?trk=profile-badge'>马章竞的 LinkedIn 主页</a>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                      <!--<p class="lead">Java 技术</p>
                      <p>OOP、FP、NIO、Internet、JUC、JavaFx、
                        Servlet、JSP、JSTL、EL、MongoDB、MySQL、JDBC、Hibernate、Spring、Spring MVC、Shiro、Maven、Spring Boot</p>
                      <p class="lead">其它技术</p>
                      <p>Python（PyQt、numpy、pandas、matplotlib）、Javascript（HTML、CSS、Less、Vue）、C、Scala、VB.NET</p>-->
                      <a href="https://blog.mazhangjing.com">我的博客</a>（<a href="https://blog-cn.mazhangjing.com">国内镜像</a>）
                    </div>
                    <div class="tab-pane fade" id="v-pills-design" role="tabpanel" aria-labelledby="v-pills-design-tab">
                      ...
                      <!--<p class="lead">平面设计</p>
                      <p>Adobe Photoshop、Adobe Illustrator、Adobe Premiere Pro</p>
                      <p class="lead">排版印刷</p>
                      <p>Adobe InDesign、Adobe Acrobat</p>-->
                    </div>
                    <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">...</div>
                    <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">...</div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="tab-pane" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            <div class="pt-5 pl-4">
              <p>Github: <a href="https://github.com/corkine" target="_blank">@Corkine</a></p>
              <p>博客：<a href="https://blog.mazhangjing.com">blog.mazhangjing.com</a> |
              <a href="https://blog-cn.mazhangjing.com">国内镜像</a> </p>
              <p>邮箱：meet@mazhangjing.com</p>
              <p>电话：MTMwODQ5OTk0NDU=</p>
              <p>联系请发邮件，我将在1-2天内回复您</p>
              <p>Update: {{update}}</p>
            </div>
          </div>

          <div class="tab-pane" id="contact2" role="tabpanel" aria-labelledby="contact2-tab">
            <div class="pt-4 pl-4">
              <p><a target="_blank" href="http://status.mazhangjing.com">▷ 服务可用性查询</a> </p>
              <p>网站地址可用性说明：主站域名 <code>(www.)mazhangjing.com</code> 不会更改，类似 <code>go.mazhangjing.com/??</code>
                样式的 <code>go</code> 子域名网址在 10 年内指向和功能不会更改（如果更改将提供 302 跳转，外部服务是否可用取决于其服务提供者），主网站地址、其他子域名网站地址指向和功能不做保证。</p>
              <p>实现说明：主站已经实现了前后端分离，部署在阿里云 OSS 上，无带宽限制。
                二级域名一般部署 API 服务器，做提供主站服务之用，比如 <code>status.mazhangjing.com</code> 为 <code>mazhangjing.com/status</code>
                提供服务器连接可用性的 API 服务。二级域名的 API 服务一般由高性能 Web 服务器提供，比如 Play Framework + Akka，或者 Spring Boot。
                除了 <code>mazhangjing.com</code> 和 <code>go.mazhangjing.com</code> 的其余域名地址及服务随时存在变动的可能，不做任何保证。</p>
              <p><img src="/static/websites.png" width="100%" id="website"> </p>
              <p>Update: {{update}} · Server Version: {{version}}</p>
            </div>
          </div>

        </div>

        <div class="card-deck pt-5">
          <div class="card p-2 ">
            <blockquote class="card-body blockquote mb-0">
              <p class="mb-0 font-weight-normal small">
                Do not go gentle into that good night, <br/>Old age should burn and rave at close of day ;<br/>
                Rage,rage against the dying of the light.<br/>
                Though wise men at their end know dark is right,<br/> Because their words had forked no lightning.<br/>
              </p>
              <footer class="blockquote-footer pt-2">Dylan Thomas <cite title="Source Title">1914 - 1953</cite></footer>
            </blockquote>
          </div>
          <div class="card border-light" ></div>
        </div>

      </div>
      <div class="span4"></div>
      <footer class="mt-5">
        <div class="inner">
          <p><span v-html="footer()"></span><a href="http://www.miibeian.gov.cn/">鄂ICP备17002041号-1</a><br/>
            <a id="sw" href="https://mazhangjing.com/love">SW &</a> CM <span class="small" id="muteText">
              - Build with love by Wei.</span></p>
        </div>
      </footer>
    </div>
</template>

<script>
import Tech from "@/components/Tech";
export default {
  name: "About",
  components: {Tech},
  data() {
    return {
      version: "3.0.5",
      urls: [
        ["博客","https://blog.mazhangjing.com"],
        ["仓库","https://github.com/corkine"],
        ["短链","https://go.mazhangjing.com"],
        ["图床","https://static2.mazhangjing.com"],
        ["童话","https://stories.mazhangjing.com"],
        ["童话(SPA)","https://story.mazhangjing.com"]
      ],
      update: "2023年03月01日",
      images: ["cover.jpg", "cover-building.jpg","cover-flower.jpg","cover-view.jpg", "cover-leaf.jpg"],
      notes: ["荟园七栋的樱花，摄于华中农业大学（2016）","人文楼，摄于华中农业大学（2016）","野芷湖的荷花，摄于华中农业大学（2015）","东望庐山，摄于九江（2014）","荷叶的脉络，摄于武穴（2017）"],
      randomData: 0
    }
  },
  methods: {
    footer() {
      return "&copy; 2016 - " + new Date().getFullYear() +" Marvin Studio |&nbsp;";
    },
    random() {
      this.randomData = Math.floor(Math.random() * (this.images.length));
    },
    backgroundImage() {
      this.random();
      return "/static/" + this.images[this.randomData];
    },
    note() {
      return this.notes[this.randomData];
    }
  }
}
</script>

<style scoped>
  #sw {
    color: black;
  }
  #sw:hover {
    color: darkred;
  }
  #muteText {
    color: #949494;
  }
  #website {
    max-width: 550px;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue